export default "__VITE_ASSET__Cg9KDtV1__"